// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7prUw","badges":"styles_badges__1tb2S"};